import { createRouter, createWebHistory } from "vue-router";
import HomePage from "../components/HomePage.vue";
import SingleQuote from "../components/SingleQuote.vue";
import ApprovedLimit from "../components/ApprovedLimit.vue";
import NewApp from "@/components/NewApp.vue";
import CardDelivery from "@/components/CardDelivery.vue";
import DeclinedApp from "@/components/DeclinedApp.vue";
import DeclinedOffer from "@/components/DeclinedOffer.vue";
import CompletedApp from "@/components/CompletedApp.vue";
import ApplicationList from "@/components/ApplicationList.vue";
import UserLogin from "@/components/UserLogin.vue";
import UserOTP from "@/components/UserOTP.vue";
import TechnicalError from "@/components/TechnicalError.vue";

const routes = [
  { path: "/beyond", name: "Beyond", component: HomePage },
  { path: "/shariah", name: "Shariah", component: HomePage },
  { path: "/platinum", name: "Platinum", component: HomePage },
  // { path: "/", redirect: "/platinum" },

  {
    path: "/",
    name: "HomePage",
    component: HomePage,
  },

  {
    path: "/singlequote",
    name: "SingleQuote",
    component: SingleQuote,
  },

  {
    path: "/approvedlimit",
    name: "ApprovedLimit",
    component: ApprovedLimit,
  },

  {
    path: "/newapp",
    name: "NewApp",
    component: NewApp,
  },

  {
    path: "/carddelivery",
    name: "CardDelivery",
    component: CardDelivery,
  },

  {
    path: "/applicationlist",
    name: "ApplicationList",
    component: ApplicationList,
  },

  {
    path: "/completedapp",
    name: "CompletedApp",
    component: CompletedApp,
  },
  {
    path: "/declinedapp",
    name: "DeclinedApp",
    component: DeclinedApp,
  },
  {
    path: "/declinedoffer",
    name: "DeclinedOffer",
    component: DeclinedOffer,
  },
  {
    path: "/userlogin",
    name: "UserLogin",
    component: UserLogin,
  },

  {
    path: "/userotp",
    name: "UserOTP",
    component: UserOTP,
  },

  {
    path: "/technicalerror",
    name: "TechnicalError",
    component: TechnicalError,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});
export default router;
